export const formatDollars = dollars => "$" + dollars.toFixed(2);
export const formatDollarsRounded = dollars => "$" + dollars.toFixed(0);
